import { Component, OnInit, Output, EventEmitter, Input, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NbDialogService } from '@nebular/theme';
import * as _ from 'lodash';

@Component({
  selector: 'app-select-permissionsgroup',
  templateUrl: './select-permissionsgroup.component.html',
  styleUrls: ['./select-permissionsgroup.component.scss']
})
export class SelectPermissionsgroupComponent implements OnInit {
 
    @Output() emitClose = new EventEmitter();
    @Output() emitList = new EventEmitter();
    @Input() orgData: Array<any>;  //已選資料_來源
    @Input() title: string; 
    mainDataList: Array<any>; //已選資料
    infoList: Array<any>;     //選項資料
    showList: Array<any>;     //顯示資料
    @Input() info : {//其他設定
      IsLoding:boolean
    ORG_Company_ID: number,
      ORG_Store_ID: number,
    };  
    query : {  //查詢選項
      searchKey : string
    } 
    status: { //當前狀態
      isSelectAll : boolean //是否已全選
      showType:number // 顯示有選過的
    }
    list={
      showType : [
        {name:"全部",value:0},
        {name:"已選",value:1},
        {name:"未選",value:2}]
    }
  
  
    modalRef = null;  //談窗鉤子
    
  
    constructor(
      private dialogService: NbDialogService,
      private http: HttpClient,
    ) { }  
    
    ngOnInit(): void {
     this.query = { searchKey :""}

    }  
  
    ngAfterViewInit(){   
      this.onOpen(this.info, this.orgData) 
    }
  
    //打開選擇附加品項
  
    @ViewChild('Modal') Modal :TemplateRef<any>
    onOpen(info,data) {
     
  
      if(info){
        this.info = info
      }
      if(data){
        this.orgData = data
      }
        
      //初始化查詢資料
      this.query.searchKey = ""
      this.mainDataList = []
      this.status= { 
        isSelectAll : true,
        showType:0
      }
      
      //處理已選資料
      if(this.orgData && this.orgData.length > 0){      
        this.mainDataList = _.cloneDeep(this.orgData)
      }    
      
      //撈取可選資料 並合成已選資料
      this.onQuery() 
  
      //開啟談窗
      this.modalRef = this.dialogService.open(this.Modal, {})
      this.modalRef.onClose.subscribe(result => {
        this.emitClose.emit(true);
      });
    }  
  
    //查詢
    onQuery( ) {
      
      this.getInfoList((data)=>{
        
        //初始化
        this.infoList = data
        this.showList = data
        this.showList.forEach(x => {
  
          let obj = _.find(this.mainDataList, y => this.judgeSame(y,x))
          if (obj) {
            x.isSelect = true
          } else {
            x.isSelect = false
          }
        })
  
        this.filterShowType()
        this.judgeSelectAll()
  
      });
  
    }
  
    onShowType(){
      this.filterShowType()
      this.judgeSelectAll()
    }
  
    //選擇
    onSelect(isAdd:boolean, item ) {
      if(isAdd){
        item.isSelect = true
        this.mainDataList.push(item);
  
      }else{
        item.isSelect = false
        let index = this.mainDataList.findIndex(x=>this.judgeSame(x,item))
        this.mainDataList.splice(index, 1);
      }    
  
      this.judgeSelectAll()
    }
  
    //全選
    onSelectAll(){
      
      
      if(this.status.isSelectAll){
        this.showList.forEach(item=>{
          item.isSelect = false
          let index = this.mainDataList.findIndex(x=>this.judgeSame(x,item))
          this.mainDataList.splice(index, 1);
        })
      }
      else{      
        this.showList.forEach(item=>{
          item.isSelect = true
          this.mainDataList.push(item);
        })
      }
      
      this.status.isSelectAll = !this.status.isSelectAll
    }
  
    //處存
    onSave() {
      
      this.orgData.splice(0,this.orgData.length );
      let i = 1;
      this.mainDataList.forEach(x=>{      
        x.Sorting = i;
        i++
        this.orgData.push(x)
      })  
      
      this.emitList.emit(this.orgData)
      this.modalRef.close()
  
    }
  
    //---------------------------------------------------------------
   
    //過濾已選未選等
    filterShowType(){
      if(this.status.showType==0){
        this.showList = _.concat([],this.infoList)
      }
      else if(this.status.showType==1){
        this.showList = _.filter(this.infoList,x=>x.isSelect)
      }
      else{
        this.showList = _.filter(this.infoList,x=> !x.isSelect)
      }
    }

    //判斷是否全選
    judgeSelectAll(){
      if(!this.showList || this.showList.length==0){
        return true
      } 
    
      this.status.isSelectAll = this.showList.every(x=>{
        return this.mainDataList.some(y=>this.judgeSame(y,x))    
      })
      
  
    }
  

    //-------------------------------------客製化區--------------------------------------------------------

    //比較
    judgeSame(y , x){
      return y.SYS_PermissionGroupID == x.SYS_PermissionGroupID 
      
    }
  
     
    //取得選擇附加品項清單
    getInfoList( callback) {
      //取得含有商品的附加品項
      this.info.IsLoding= true
      this.http.get<any>('api/PermissionGroup/GetPermissionGroupList?' +
        "ORG_Store_ID="+ this.info.ORG_Store_ID+
        '&AuthType=2'+  
        '&IsDelete=false'+
        '&Page=1' +'&PerPage=2147483647' ).subscribe({
        next: data => {
  
          if(callback)
            callback(data.permissionGroups)    
            
        this.info.IsLoding= false
            
  
        },
        error: error => {
          console.error('There was an error!', error);
        this.info.IsLoding= false

        }
      });
  
    }

    



  

    
  
  
  }
  
  
  
  
  
